export default __webpack_public_path__ + "static/media/mapview-Default.6955f931.svg";